import { getGeo } from 'services/geo';

export const LOAD_GEO = 'LOAD_GEO';

export default function geo(state = null, action) {
  switch (action.type) {
    case LOAD_GEO:
      return action.payload;
    default:
      return state;
  }
}

export function loadGeo() {
  return dispatch => {
    return getGeo().then(geo => {
      dispatch({
        type: LOAD_GEO,
        payload: geo
      });
      return geo;
    })
    .catch(error => {
      throw error;
    });
  };
}

export function setGeo(geo) {
  return dispatch => {
    dispatch({
      type: LOAD_GEO,
      payload: geo
    });
    return geo;
  };
}
